<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input
          @keyup.enter.native="handleFilter"
          size="mini"
          style="width: 200px"
          class="filter-item"
          :placeholder="'名称'"
          v-model="listQuery.key"
        >
        </el-input>
        <el-button
          class="filter-item"
          size="mini"
          v-waves
          icon="el-icon-search"
          @click="handleFilter"
          >搜索</el-button
        >
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%">
        <el-table
          height="calc(100% - 52px)"
          ref="mainTable"
          :key="tableKey"
          :data="list"
          v-loading="listLoading"
          border
          fit
          style="width: 100%"
        >
          <el-table-column :label="'单号'" min-width="60px">
            <template slot-scope="scope">
              <span class="link-type" @click="handleDetail(scope.row)">{{
                scope.row.id
              }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'投诉类型'" min-width="60px">
            <template slot-scope="scope">
              <span>{{ scope.row.complaintType }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'投诉时间'" min-width="60px">
            <template slot-scope="scope">
              <span>{{ scope.row.submitTime }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'投诉人途聆ID'" min-width="60px">
            <template slot-scope="scope">
              <span>{{ scope.row.submitterAccount }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'设备SN'" min-width="60px">
            <template slot-scope="scope">
              <span>{{ scope.row.sn }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'队伍Id'" min-width="60px">
            <template slot-scope="scope">
              <span>{{ scope.row.channelId }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'队伍名称'" min-width="60px">
            <template slot-scope="scope">
              <span>{{ scope.row.channelName }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'事件开始'" min-width="60px">
            <template slot-scope="scope">
              <span>{{ scope.row.occuredBegin }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'事件结束'" min-width="60px">
            <template slot-scope="scope">
              <span>{{ scope.row.occuredEnd }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'状态'" min-width="40px">
            <template slot-scope="scope">
              <span>{{ scope.row.status }}</span>
            </template>
          </el-table-column>

          <el-table-column min-width="60px">
            <template slot-scope="scope">
              <div class="filter-items">
                <el-button
                  v-if="btnReceive && scope.row.status == '已提交'"
                  :type="btnReceive.class"
                  size="mini"
                  class="filter-item"
                  @click="onBtnClicked('btnReceive', scope.row)"
                  >{{ btnReceive.name }}
                </el-button>
                <el-button
                  v-if="btnClose && scope.row.status == '调查中'"
                  :type="btnClose.class"
                  size="mini"
                  class="filter-item"
                  @click="onBtnClicked('btnClose', scope.row)"
                  >{{ btnClose.name }}
                </el-button>

                <el-button
                  v-if="btnClose && scope.row.status == '已办结[禁言]'"
                  :type="btnClose.class"
                  size="mini"
                  class="filter-item"
                  @click="restoreChannel(scope.row.id)"
                  >解禁
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="handleCurrentChange"
        />
      </div>

      <el-dialog
        v-el-drag-dialog
        class="dialog-mini"
        width="900px"
        :title="'详情'"
        :visible.sync="dialogDetailVisible"
      >
        <el-tabs v-model="activeTab" type="border-card">
          <el-tab-pane label="基本信息" name="baseinfo">
            <el-row class="oddbg">
              <el-col :span="12">
                <label class="label">单号：</label>
                <label class="field">{{ temp.id }}</label>
              </el-col>
              <el-col :span="12">
                <label class="label">状态：</label>
                <label class="field">{{ temp.status }}</label>
                <el-button  v-if="btnClose && temp.status == '已办结[禁言]'"
                  type="primary" size="mini" round plain @click="restoreChannel(temp.id)">解禁</el-button>

              </el-col>
            </el-row>

            <el-row class="evenbg">
              <el-col :span="12">
                <label class="label">投诉人：</label>
                <label class="field">{{ temp.submitterAccount }}</label>
              </el-col>
              <el-col :span="12">
                <label class="label">投诉时间：</label>
                <label class="field">{{ temp.submitTime }}</label>
              </el-col>
            </el-row>

            <el-row class="oddbg">
              <el-col :span="12">
                <label class="label">投诉类型：</label>
                <label class="field">{{ temp.complaintType }}</label>
              </el-col>
              <el-col :span="12">
                <label class="label">设备SN：</label>
                <label class="field">{{ temp.sn }}</label>
              </el-col>
            </el-row>

            <el-row class="evenbg">
              <el-col :span="12">
                <label class="label">队伍Id：</label>
                <label class="field">{{ temp.channelId }} </label>
                <!-- <el-button type="warning" size="mini" round plain @click="blockChannel(temp.channelId)">禁言</el-button>
                <el-button type="primary" size="mini" round plain @click="restoreChannel(temp.channelId)">解禁</el-button>
                <el-button type="danger" size="mini" round plain @click="dismissChannel(temp.channelId)">解散</el-button> -->
              </el-col>
              <el-col :span="12">
                <label class="label">队伍名称：</label>
                <label class="field">{{ temp.channelName }}</label>
              </el-col>
            </el-row>

            <el-row class="oddbg">
              <el-col :span="12">
                <label class="label">开始时间：</label>
                <label class="field">{{ temp.occuredBegin }}</label>
              </el-col>
              <el-col :span="12">
                <label class="label">结束时间：</label>
                <label class="field">{{ temp.occuredEnd }}</label>
              </el-col>
            </el-row>

            <el-row class="evenbg">
              <el-col :span="24" style="display: flex">
                <label class="label"> 违规内容： </label>
                <label class="field">
                  {{ temp.description }}
                </label>
              </el-col>
            </el-row>

            <el-divider content-position="left">附件</el-divider>

            <el-row v-for="(audio, index) in temp.audios" :key="index">
              <el-col :span="8">
                <label class="field">{{ audio.key }}</label>
              </el-col>
              <el-col :span="16">
                <a class="field" :href="audio.value" target="_blank">{{
                  audio.value
                }}</a>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="处理流程" name="process">
            <el-row :class="{oddbg:index%2==0,evenbg:index%2==1}" v-for="(log,index) in logs" :key="index">
              <el-col :span="8">
                <label class="field">{{ log.actionTime }}</label>
              </el-col>
              <el-col :span="8">
                <label class="field">{{ log.actionBy }}</label>
              </el-col>
              <el-col :span="8">
                <label class="field">{{ log.action }}</label>
              </el-col>
            </el-row>

            <el-divider content-position="left" v-if="temp.results">处理结果</el-divider>
            <el-row class="evenbg" v-if="temp.results" style="justify-content: left;">
              <label class="field">
                {{ temp.results }}
              </label>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
    
      <el-dialog
        v-el-drag-dialog
        class="dialog-mini"
        width="600px"
        :title="'结案'"
        :visible.sync="dialogFormVisible"
      >
        <el-form ref="closeForm" :model="closeform" :rules="rules" label-width="80px">
          <el-form-item label="群组处理" prop="closeType">
            <el-select v-model="closeform.closeType" placeholder="请选择">
              <el-option :value="0" :label="'不处理'"></el-option>
              <el-option :value="1" :label="'禁言'"></el-option>
              <el-option :value="2" :label="'解散'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理说明" prop="results">
            <el-input type="textarea" v-model="closeform.results"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="updateData">确定</el-button>
            <el-button @click="dialogFormVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import * as complaints from "@/api/complaints";
import waves from "@/directive/waves"; // 水波纹指令
import Sticky from "@/components/Sticky";
import Pagination from "@/components/Pagination";
import elDragDialog from "@/directive/el-dragDialog";
import extend from "@/extensions/common.js";
export default {
  name: "complaint",
  components: { Sticky, Pagination },
  directives: {
    waves,
    elDragDialog,
  },
  mixins: [extend],
  data() {
    return {
      activeTab: "baseinfo",
      btns: [],
      btnReceive: null,
      btnClose: null,

      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        // 查询条件
        page: 1,
        limit: 20,
        key: undefined,
      },
      temp: {},
      logs: null,
      closeform:{
        closeType:'',
        results:''
      },
      rules: {          
          closeType: [
            { required: true, message: '请选择群组处理方法', trigger: 'blur' }
          ],
          results: [
            { required: true, message: '请填写处理说明', trigger: 'blur' }
          ]
        },
      dialogFormVisible: false,
      dialogDetailVisible: false,
    };
  },
  created() {
    this.getList();

    this.btns = this.$route.meta.elements;
    this.btnReceive = this.btns.find((ele) => ele.domId == "btnReceive");
    this.btnClose = this.btns.find((ele) => ele.domId == "btnClose");
  },
  methods: {
    onBtnClicked: function (domId, row) {
      switch (domId) {
        case "btnReceive":
          this.$confirm("是否开始调查此投诉?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              complaints
                .receive({ id: row.id })
                .then(() => {
                  row.status = "调查中";
                  this.$message({
                    type: "success",
                    message: "提交成功",
                  });
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "处理失败，请稍后再试",
                  });
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            });

          break;
        case "btnClose":
          this.handleUpdate(row);
          break;
        default:
          break;
      }
    },
    getList() {
      this.listLoading = true;
      complaints.getList(this.listQuery).then((response) => {
        this.list = response.data;
        this.total = response.count;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page;
      this.listQuery.limit = val.limit;
      this.getList();
    },

    resetTemp() {
      let obj = {};
      this.temp = Object.assign({}, obj); // copy obj
    },

    handleUpdate(row) {
      // 弹出编辑框
      this.temp = Object.assign({}, row); // copy obj
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["closeForm"].clearValidate();
      });
    },
    updateData() {
      let that = this;
      // 更新提交
      this.$refs["closeForm"].validate((valid) => {
        if(!valid){
          return;
        }
        const tempData = {
          id:that.temp.id,
          closeType: that.closeform.closeType,
          results: that.closeform.results
        };
        complaints.close(tempData).then(() => {
          //that.temp.status = '已结案';
          that.closeform = {
            closeType:'',
            results:''
          };
          that.getList();
          that.dialogFormVisible = false;
          that.$notify({
            title: "成功",
            message: that.btnClose.name + "成功",
            type: "success",
            duration: 2000,
          });
        });
      });
    },
    handleDetail(row) {
      // 弹出详情
      let that = this;
      complaints.getAuditLogs(row.id).then(res=>{
        that.logs = res.result
      });
      that.temp = Object.assign({}, row); // copy obj
      that.dialogDetailVisible = true;
    },
    restoreChannel(cid){
      console.log(cid);
      let that = this;
      that.$confirm('是否解禁该口令频道?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          complaints.restore({id:cid})
          .then(res=>{
            if(res.code == 200){
              this.dialogDetailVisible = false;
              that.getList();
              that.$message({
                type: 'success',
                message: '口令频道已解禁!'
              });
            } else {              
              that.$message({
                type: 'success',
                message: '解禁失败，请稍后重试!'
              });
            }
          })
          .catch(err=>{
            console.log(err);
            that.$message({
                type: 'success',
                message: '解禁失败，请稍后重试!'
              });
          });
        }).catch(() => {
          that.$message({
            type: 'info',
            message: '已取消'
          });          
        });
    }

  },
};
</script>
<style scoped>
.dialog-mini .el-select {
  width: 100%;
}
.label {
  display: inline-block;
  font-weight: 600;
  margin: 5px 12px;
  width: 70px;
  flex-shrink: 0;
}

.field {
  font-weight: 400;
  padding: 5px 12px;
}

.el-row {
  height: 45px;
  padding: 15px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.oddbg {
  background: #ffffff;
}
.evenbg {
  background: #f2f6fc;
}
</style>
